import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enCommon from './locales/en-us/common.json';
import enTools from './locales/en-us/tools.json';
import enConverter from './locales/en-us/converter.json';
import enConfiguration from './locales/en-us/configuration.json';
import enBankDropdown from './locales/en-us/bankDropdown.json';
import enServerManagement from './locales/en-us/serverManagement.json';
import enImport from './locales/en-us/import.json';
import enServer from './locales/en-us/server.json';
import enAuth from './locales/en-us/auth.json';
import enPricing from './locales/en-us/pricing.json';
import enBetaModal from './locales/en-us/betaModal.json';
import enFeatures from './locales/en-us/features.json';
import enOnboarding from './locales/en-us/onboarding.json';
import enBudget from './locales/en-us/budget.json';
import enOverspend from './locales/en-us/overspend.json';

import arCommon from './locales/ar-eg/common.json';
import arTools from './locales/ar-eg/tools.json';
import arConverter from './locales/ar-eg/converter.json';
import arConfiguration from './locales/ar-eg/configuration.json';
import arBankDropdown from './locales/ar-eg/bankDropdown.json';
import arServerManagement from './locales/ar-eg/serverManagement.json';
import arImport from './locales/ar-eg/import.json';
import arServer from './locales/ar-eg/server.json';
import arAuth from './locales/ar-eg/auth.json';
import arPricing from './locales/ar-eg/pricing.json';
import arBetaModal from './locales/ar-eg/betaModal.json';
import arFeatures from './locales/ar-eg/features.json';
import arOnboarding from './locales/ar-eg/onboarding.json';
import arBudget from './locales/ar-eg/budget.json';
import arOverspend from './locales/ar-eg/overspend.json';

import esCommon from './locales/es-es/common.json';
import esTools from './locales/es-es/tools.json';
import esConverter from './locales/es-es/converter.json';
import esConfiguration from './locales/es-es/configuration.json';
import esBankDropdown from './locales/es-es/bankDropdown.json';
import esServerManagement from './locales/es-es/serverManagement.json';
import esImport from './locales/es-es/import.json';
import esServer from './locales/es-es/server.json';
import esAuth from './locales/es-es/auth.json';
import esPricing from './locales/es-es/pricing.json';
import esBetaModal from './locales/es-es/betaModal.json';
import esFeatures from './locales/es-es/features.json';
import esOnboarding from './locales/es-es/onboarding.json';
import esBudget from './locales/es-es/budget.json';
import esOverspend from './locales/es-es/overspend.json';

import frCommon from './locales/fr-fr/common.json';
import frTools from './locales/fr-fr/tools.json';
import frConverter from './locales/fr-fr/converter.json';
import frConfiguration from './locales/fr-fr/configuration.json';
import frBankDropdown from './locales/fr-fr/bankDropdown.json';
import frServerManagement from './locales/fr-fr/serverManagement.json';
import frImport from './locales/fr-fr/import.json';
import frServer from './locales/fr-fr/server.json';
import frAuth from './locales/fr-fr/auth.json';
import frPricing from './locales/fr-fr/pricing.json';
import frBetaModal from './locales/fr-fr/betaModal.json';
import frFeatures from './locales/fr-fr/features.json';
import frOnboarding from './locales/fr-fr/onboarding.json';
import frBudget from './locales/fr-fr/budget.json';
import frOverspend from './locales/fr-fr/overspend.json';

const resources = {
  'en-US': {
    common: enCommon,
    tools: enTools,
    converter: enConverter,
    configuration: enConfiguration,
    bankDropdown: enBankDropdown,
    serverManagement: enServerManagement,
    import: enImport,
    server: enServer,
    auth: enAuth,
    pricing: enPricing,
    betaModal: enBetaModal,
    features: enFeatures,
    onboarding: enOnboarding,
    budget: enBudget,
    overspend: enOverspend,
  },
  'ar-EG': {
    common: arCommon,
    tools: arTools,
    converter: arConverter,
    configuration: arConfiguration,
    bankDropdown: arBankDropdown,
    serverManagement: arServerManagement,
    import: arImport,
    server: arServer,
    auth: arAuth,
    pricing: arPricing,
    betaModal: arBetaModal,
    features: arFeatures,
    onboarding: arOnboarding,
    budget: arBudget,
    overspend: arOverspend,
  },
  'es-ES': {
    common: esCommon,
    tools: esTools,
    converter: esConverter,
    configuration: esConfiguration,
    bankDropdown: esBankDropdown,
    serverManagement: esServerManagement,
    import: esImport,
    server: esServer,
    auth: esAuth,
    pricing: esPricing,
    betaModal: esBetaModal,
    features: esFeatures,
    onboarding: esOnboarding,
    budget: esBudget,
    overspend: esOverspend,
  },
  'fr-FR': {
    common: frCommon,
    tools: frTools,
    converter: frConverter,
    configuration: frConfiguration,
    bankDropdown: frBankDropdown,
    serverManagement: frServerManagement,
    import: frImport,
    server: frServer,
    auth: frAuth,
    pricing: frPricing,
    betaModal: frBetaModal,
    features: frFeatures,
    onboarding: frOnboarding,
    budget: frBudget,
    overspend: frOverspend,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en-US',
    defaultNS: 'common',
    ns: ['common', 'tools', 'converter', 'configuration', 'bankDropdown', 'serverManagement', 'import', 'server', 'auth', 'pricing', 'betaModal', 'features', 'onboarding', 'budget', 'overspend'],
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  });

// Add RTL support
i18n.on('languageChanged', (lng) => {
  const isRTL = lng === 'ar-EG';
  document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
  document.documentElement.setAttribute('lang', lng);
});

// Set initial direction
const currentLang = i18n.language || 'en-US';
const isRTL = currentLang === 'ar-EG';
document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
document.documentElement.setAttribute('lang', currentLang);

export default i18n; 